import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke313aRequest, Sgke313aResponse, Sgke313aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke313aService {

  /**
   * コンストラクタ
   * @param {Sgke313aService} sgke313aService
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke313aService
   */
  constructor(
    private service: Sgke313aService,
    private apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 供給停止予定登録API呼び出し
   * @param {Sgke313aRequest} request
   * @return {*}  {Observable<Sgke313aResponse>}
   * @memberof UsedSgke313aService
   */
  public doSgke313a(request: Sgke313aRequest): Observable<Sgke313aResponse> {
    //日付のフォーマットをYYMMDDに変更
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    return this.service.SGKE313APost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE313A');
          return throwError(err.message);
        })
      );
  }
}
